import { css } from '@emotion/core';
import theme from '../../themes/default';
import styleUtils from '../../styles/utils';

const titleContainer = css`
  flex: 1;
  display: flex;
  align-items: center;

  font-size: ${theme.font.size.large};
  font-weight: ${theme.font.weight.medium};
`;

const hintContainer = css`
  color: ${theme.color.grey10};
  font-size: ${theme.font.size.small};
  font-weight: ${theme.font.weight.regular};
`;

const headerIcon = css`
  width: 24px;
  height: 24px;
  margin-right: 16px;
  font-style: normal;
`;

const container = css`
  ${styleUtils.flex.container()};
  width: 100%;
  height: 100%;
`;

const itemSmall = css`
  width: calc(100% - ${theme.spacing.small});
  height: 528px;
`;

const itemFullscreen = css`
  height: calc(100vh - 64px);
  width: calc(100% - 64px);
`;

const itemMedium = css`
  max-width: 600px;
  width: 100%;
`;

const itemDefault = css`
  width: auto;
  height: auto;
`;

const paper = css`
  display: flex;
  flex-direction: column;

  background-color: ${theme.color.white};
  border-bottom-left-radius: ${theme.borderRadius.medium};
  border-bottom-right-radius: ${theme.borderRadius.medium};
  border-top-left-radius: ${theme.borderRadius.medium};
  border-top-right-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadow.xHigh};
`;

const header = css`
  box-sizing: border-box;
  display: flex;
  background-color: ${theme.color.beige};
  height: 72px;
  width: 100%;
  align-items: center;
  padding-left: ${theme.spacing.small};
  padding-right: ${theme.spacing.small};
  align-self: center;
  border-top-left-radius: ${theme.borderRadius.medium};
  border-top-right-radius: ${theme.borderRadius.medium};
`;

const closeBtn = css`
  margin-right: ${theme.spacing.small};
`;

export default {
  container: {
    base: container,
  },
  header: {
    base: header,
    closeBtn,
    headerIcon,
    titleContainer,
    hintContainer,
  },
  paper: {
    base: paper,
    bySize: {
      small: itemSmall,
      medium: itemMedium,
      fullscreen: itemFullscreen,
      default: itemDefault,
    },
  },
};
